/*
 * @Author:
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-05-15 13:20:58
 * @Description:
 */
import type { GameHistoryReponseStateType, HistoryOnJoinStateType } from './dto/index.dto';
import { useCoinFlip } from './coinflip';
import { useSpaceDice } from './spaceDice';
import { useCrashSocket } from './crash';
import { usePlinko } from './plinko';
import { useLimbo } from './limbo';
import { useDice } from './dice';
import { useRingSocket } from './ring';
import { useCryptosSocket } from './cryptos';
import { useTowerSocket } from './tower';
import { useStairsSocket } from './stairs';
import { useCorgiWild } from './corgiwild';
import { useRouleeteSocket } from './roulette';
import { useKenoSocket } from './keno';
import { useHiloSocket } from './hilo';
import { useMinesSocket } from './mines';
import { usePharaohSocket } from './pharaoh';
import { useCircleSocket } from './circle';
import { useTripleSocket } from './triple';
import { useBlackJackSocket } from './blackJack';

export const useGameSocket = () => {
    const basePath = 'games';

    const EMIT_SUBSCRIBE_ALL = (sGameApi:string) => {
        socket.emit(`games.${sGameApi}.subscribeAll`, {}, () => {
            console.log('subscribeAll', sGameApi);
        });
    };
    const EMIT_UNSUBSCRIBE_ALL = (sGameApi) => {
        socket.emit(`games.${sGameApi}.unSubscribeAll`, {}, () => {
            console.log('unSubscribeAll', sGameApi);
        });
    };

    // 👇 查询游戏下方的大表格其中“3项”数据： all, high, rare
    const EMIT_GETHISTORY_ON_JOIN = (
        sGameApi:string,
        data: any,
        callback: (data: HistoryOnJoinStateType) => any,
    ) => {
        socket.emit(
            `games.${sGameApi}.getHistoryOnJoin`,
            data, 
            (theData)=>{
                fixHistoryData(theData.all);
                fixHistoryData(theData.high);
                fixHistoryData(theData.rare);
                callback(theData);
            },
        );
    };
    // 👇 实时的，逐条的接收游戏最新记录
    const ON_GAME_HISTORY_ON_HISTORY = (
        sGameApi:string,
        callback: (data: GameHistoryReponseStateType) => any,
    ): (() => void) => {
        console.log(`开始逐条接收 ${sGameApi} 游戏歷史`);
        const fullName = `${sGameApi}bethistory`;
        const fnCallbackWrap = (obj)=>{
            fixHistoryData([obj]);
            callback(obj);
        };
        socket.on(fullName, fnCallbackWrap);
        // 👇取消接收
        const stopReceiving = () => {
            socket.off(fullName, fnCallbackWrap);
        };
        return stopReceiving;
    };

    // 👇 在进入游戏时调用，可查询到当前游戏的下注上限金额等信息
    const EMIT_GAME_JOIN = (
        sGameApi,
        data: any, // 通常是空对象，以抢红包游戏时是房间号（桌号） 
        callback: any,
    ) => {
        const sURL = `games.${sGameApi}.join`; 
        socket.emit(sURL, data, callback);
    };

    // 👇 在“离开” 游戏时调用，宣告已经离开某游戏 
    const EMIT_GAME_EXIT = (
        sGameApi,
    ) => {
        const sURL = `games.${sGameApi}.exit`; 
        socket.emit(sURL, {}, ()=>{
            console.log('已经离开游戏：', sURL); // 不会打印，因为没有返回值 
        });
    };

    return {
        ...useCoinFlip(basePath),
        ...useSpaceDice(basePath),
        ...useCrashSocket(basePath),
        ...usePlinko(basePath),
        ...useLimbo(basePath),
        ...useDice(basePath),
        ...useRingSocket(basePath),
        ...useCryptosSocket(basePath),
        ...useTowerSocket(basePath),
        ...useStairsSocket(basePath),
        ...useCorgiWild(basePath),
        ...useRouleeteSocket(basePath),
        ...useKenoSocket(basePath),
        ...useHiloSocket(basePath),
        ...useMinesSocket(basePath),
        ...usePharaohSocket(basePath),
        ...useCircleSocket(basePath),
        ...useTripleSocket(basePath),
        ...useBlackJackSocket(basePath),
        EMIT_SUBSCRIBE_ALL,
        EMIT_UNSUBSCRIBE_ALL,
        EMIT_GETHISTORY_ON_JOIN,
        ON_GAME_HISTORY_ON_HISTORY,
        EMIT_GAME_JOIN,
        EMIT_GAME_EXIT,
    };
};

// 返回的历史记录不规范，因此用它修正
export function fixHistoryData(arr){
    if (!arr?.length) return;
    arr.forEach(cur => {
        if (typeof cur.multi == 'string'){
            cur.multi = Number(cur.multi);
        }
        // ↓ 在 crash 游戏，需要手工补充 multi 属性 
        const aIdList = [cur.gameId, cur.game?.id];
        if (aIdList.includes(7)){
            cur.multi ??= Number(cur.stopped);
        }
    });
    return arr;
}
